<template>
  <div class="w-full">
    <div class="division" style="padding-top:25vh" id="logo">
      <header>
        <h1>Logo</h1>
      </header>
    </div>
    <section class="px-4 text-center">
      <div class="max-w-3xl mx-auto my-8 text-center">
        <img src="img/logo/elements_logo_color_green.svg" width="250px" alt="main">
      </div>
    </section>
    <section class="px-4 text-center neo-inverse">
      <div class="max-w-3xl mx-auto my-8 text-center">
        <img src="img/logo/elements_logo_color_white.svg" width="250px" alt="main">
      </div>
    </section>


    <div class="division my-32" id="colors">
      <header>
        <h1>Main Color</h1>
      </header>
    </div>
    <section class="px-4 py-32 text-center neo-inverse">
      <div class="max-w-3xl mx-auto my-8 text-center">
        <h2>Pantone 7221C</h2>
      </div>
    </section>

    <div class="division mt-32" id="font">
      <header>
        <h1>Fonts</h1>
        <div class="max-w-3xl mx-auto">
          <h2 class="mt-4 font-bold text-4xl">Neue Haas Unica</h2>
          <p class="text-base text-blue-600"><a target="_blank" href="https://fonts.adobe.com/fonts/neue-haas-unica">Adobe Fonts &rarr;</a></p>
        </div>
      </header>
    </div>
    <section class="px-4 py-32 text-center neo-inverse">
      <div class="max-w-3xl mx-auto my-8 text-center">
        <img src="img/font_preview.png" alt="font" style="width: 100%; height: auto">
      </div>
    </section>

    <div class="division mt-20" style="padding-bottom: 25vh">
      <prev-next/>
    </div>
  </div>
</template>

<script>

export default {
  name: "base-graphics"
}
</script>

<style scoped>

</style>